import {
  Activity,
  GitBranch,
  LayoutDashboard,
  Package,
  Settings,
  ShoppingCart,
  Stamp,
  Tags,
  Upload,
  User,
  Users,
} from "lucide-react";

export const navigationItems = [
  {
    label: "Dashboard",
    path: "/",
    icon: LayoutDashboard,
    description: "Store health, revenue pulse, and inventory alerts.",
    matches: (pathname) => pathname === "/",
  },
  {
    label: "Products",
    path: "/products",
    icon: Package,
    description: "Catalog structure, pricing, and merchandising rules.",
    matches: (pathname) => pathname.startsWith("/products"),
  },
  {
    label: "Catalog Import",
    path: "/catalog-import",
    icon: Upload,
    description: "Excel batch upload, preview, and confirm flow for product-service catalog imports.",
    matches: (pathname) => pathname.startsWith("/catalog-import"),
  },
  {
    label: "Categories",
    path: "/categories",
    icon: Tags,
    description: "Aisles, thumbnails, and storefront organization.",
    matches: (pathname) => pathname.startsWith("/categories"),
  },
  {
    label: "Brands",
    path: "/brands",
    icon: Stamp,
    description: "Brand registry, logos, and activation status.",
    matches: (pathname) => pathname.startsWith("/brands"),
  },
  {
    label: "Orders",
    path: "/orders",
    icon: ShoppingCart,
    description: "Fulfillment status, payment health, and delivery flow.",
    matches: (pathname) => pathname.startsWith("/orders"),
  },
  {
    label: "Customers",
    path: "/customers",
    icon: Users,
    description: "Segments, lifetime value, and repeat purchase activity.",
    matches: (pathname) => pathname.startsWith("/customers"),
  },
  {
    label: "Operations",
    path: "/operations",
    icon: Activity,
    description: "Low-stock queue, sync notes, and merchandising checks.",
    matches: (pathname) => pathname.startsWith("/operations"),
  },
  {
    label: "Workflow Management",
    path: "/workflow-management",
    icon: GitBranch,
    description: "Workflow definitions, statuses, states, and transition rules.",
    matches: (pathname) => pathname.startsWith("/workflow-management"),
  },
  {
    label: "Settings",
    path: "/settings",
    icon: Settings,
    description: "Workspace defaults, API mode, and local operational state.",
    matches: (pathname) => pathname.startsWith("/settings"),
  },
  {
    label: "Profile",
    path: "/profile",
    icon: User,
    description: "Personal account details and session controls.",
    matches: (pathname) => pathname.startsWith("/profile"),
    hidden: true,
  },
];

export function getNavigationItem(pathname) {
  return navigationItems.find((item) => item.matches(pathname)) || navigationItems[0];
}
